import React from 'react';
import ProductHeaderDesktop from './product-header-desktop';
import ProductHeaderMobile from './product-header-mobile';
import Viewport, { ViewportContext } from '../../../../components/viewport';
import { ProductHeaderProps } from './types';

const ProductHeader = React.memo((props: ProductHeaderProps) => (
  <>
    <Viewport desktop tablet>
      <ProductHeaderDesktop {...props} />
    </Viewport>
    <Viewport mobile>
      <ProductHeaderMobile {...props} />
    </Viewport>
  </>
));

export default React.forwardRef((props: ProductHeaderProps, ref) => (
  <ViewportContext.Consumer>
    {({ isDesktop }) => (
      <ProductHeader {...props} showPriceHistory={isDesktop} innerRef={ref} />
    )}
  </ViewportContext.Consumer>
));
